import * as Yup from "yup";
import { supportedLanguages } from "../../../constants";

export const getFormSchema = (t) => {
	const messageFields = supportedLanguages.reduce((shape, lang) => {
		shape[`message-${lang}`] = Yup.string().required(t("fill_required_fields"));
		return shape;
	}, {});

	return Yup.object().shape({
		// Message fields for each language
		...messageFields,

		// Alert type validation
		type: Yup.string().required(t("fill_required_fields")),

		// Visibility toggle
		isVisible: Yup.boolean().default(false),

		// Links
		links: Yup.array()
			.of(
				Yup.object().shape({
					text: Yup.string().required(t("fill_required_fields")),
					url: Yup.string().url().required(t("fill_required_fields")),
				})
			)
			.max(2),
	});
};
